import { NgModule } from "@angular/core";
import { EffectsModule } from "@ngrx/effects";
import { TrackingEffect } from "./tracking.effects";

@NgModule({
    declarations: [],
    imports: [
        EffectsModule.forFeature([TrackingEffect]),
    ],
    providers: []
})
export class TrackingStateModule { }
